module.exports = __webpack_public_path__ + "static/media/icon_close.55445a8a.svg";